import { render, staticRenderFns } from "./addSlotforCottage.vue?vue&type=template&id=4bbf4375"
import script from "./addSlotforCottage.vue?vue&type=script&lang=js"
export * from "./addSlotforCottage.vue?vue&type=script&lang=js"
import style0 from "./addSlotforCottage.vue?vue&type=style&index=0&id=4bbf4375&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports